import GeoIP from '../geolocation/geoip';
import TotalManipulator from './TotalManipulator';

/**
 * Tailwind classes: (HACK: so its compatible with Tailwind CSS)
 *
 * class="tw-ring tw-ring-red-500"
 */

function renderEstimatesComponent() {
  const locale = JSON.parse(document.getElementById('getLocale').textContent);

  const layout = `
  <div>
    <span class="label">${locale.cart.customs.estimate}${' '}</span>
    <span class="right">
      <span class="estimated-import-fees-min"><span class="money"></span></span>
      <span class="estimated-import-fees-tilde">~</span>
      <span class="estimated-import-fees-max"><span class="money"></span></span>
    </span>
  </div>
  `;

  const estimatesParent = document.querySelector('.cart-box .cart-box-inner:nth-child(3)');
  estimatesParent.innerHTML += layout;
}

function renderEstimatePrices(value, continent, countryCode) {
  const customsInvoiceMoneyEl = document.querySelector('.customs-invoice-value .money');
  const cartPriceWithoutProtection = window.SolarisCart.cart.total_price - window.SolarisCart.protectionsTotalCost();
  const sliderPercentage = value / 100;
  const customsImportValue = Math.round(cartPriceWithoutProtection * sliderPercentage);
  TotalManipulator.updateElement(customsInvoiceMoneyEl, customsImportValue);

  let minTaxableValue = 0;
  let minTaxMultiplier = 0.17;
  let maxTaxMultiplier = 0.25;

  if (continent === 'EU') {
    minTaxableValue = 2500;
    minTaxMultiplier = 0.17;
    maxTaxMultiplier = 0.22;
  } else if (countryCode === 'CA') {
    minTaxableValue = 2000;
    minTaxMultiplier = 0.5;
  }

  const minEl = document.querySelector('.estimated-import-fees-min');
  const maxEl = document.querySelector('.estimated-import-fees-max');
  const tilde = document.querySelector('.estimated-import-fees-tilde');
  const minMoney = minEl.querySelector('.money');
  const maxMoney = maxEl.querySelector('.money');
  if (minTaxableValue > 0 && customsImportValue < minTaxableValue) {
    tilde.style.display = 'none';
    minEl.style.display = 'none';
    TotalManipulator.updateElement(maxMoney, 0);
  } else {
    const estimatedMinImportFee = customsImportValue * minTaxMultiplier;
    const estimatedMaxImportFee = customsImportValue * maxTaxMultiplier;
    tilde.style.display = 'inline';
    minEl.style.display = 'inline';
    TotalManipulator.updateElement(minMoney, estimatedMinImportFee);
    TotalManipulator.updateElement(maxMoney, estimatedMaxImportFee);
  }
}

function setTrackColor(value) {
  const root = document.documentElement;

  if (value > 66) {
    root.style.setProperty('--track-color', 'var(--track-good)');
  } else if (value > 33) {
    root.style.setProperty('--track-color', 'var(--track-warning)');
  } else {
    root.style.setProperty('--track-color', 'var(--track-danger)');
  }
}

function setDisclaimerStatus(value) {
  document.querySelector('.checkout-disclaimer').dataset.value = value;
}

function assureAgreementPromise() {
  return new Promise((resolve, reject) => {
    const containerEl = document.querySelector('.checkout-disclaimer');
    const agreementCheckbox = containerEl.querySelector('input[type="checkbox"]');

    if (agreementCheckbox.checked !== true) {
      containerEl.classList.add('error');
      agreementCheckbox.classList.add('tw-ring', 'tw-ring-red-500');
      agreementCheckbox.addEventListener(
        'change',
        (e) => {
          if (e.target.checked) {
            containerEl.classList.remove('error');
            agreementCheckbox.classList.remove('tw-ring', 'tw-ring-red-500');
          }
        },
        {
          once: true,
        },
      );

      reject();
    } else {
      resolve();
    }
  });
}

function updateEstimatesComponent(value, continent, countryCode) {
  setTrackColor(value);
  setDisclaimerStatus(value);
  renderEstimatePrices(value, continent, countryCode);
}

function addListeners(continent, countryCode) {
  const showShipping = document.querySelector('#customs-invoice-shipping-cost');
  const shippingTypeInput = document.querySelector('#customs-invoice-shipping-type');
  const slider = document.querySelector('#customs_percentage');
  const initialValue = slider.value;

  if (window.SolarisCart.cart.attributes.mark_as_gift === undefined) {
    window.SolarisCart.setAttribute('mark_as_gift', String(countryCode !== 'GB'));
    shippingTypeInput.checked = countryCode !== 'GB';
  }

  if (window.SolarisCart.cart.attributes.display_shipping_on_invoice === undefined) {
    window.SolarisCart.setAttribute('display_shipping_on_invoice', String(showShipping.checked));
  }

  updateEstimatesComponent(initialValue, continent, countryCode);

  showShipping.addEventListener('change', (e) => {
    window.SolarisCart.setAttribute('display_shipping_on_invoice', String(e.target.checked));
  });

  shippingTypeInput.addEventListener('change', (e) => {
    window.SolarisCart.setAttribute('mark_as_gift', String(e.target.checked));
  });

  slider.addEventListener('input', (evt) => {
    const { value } = evt.target;

    if (Number.isNaN(value)) return;

    updateEstimatesComponent(value, continent, countryCode);
  });

  slider.addEventListener('change', (evt) => {
    const { value } = evt.target;

    if (Number.isNaN(value)) return;

    updateEstimatesComponent(value, continent, countryCode);
    window.SolarisCart.setAttribute('customs_invoice_percentage_value', String(value));
  });
}

export const init = async () => {
  const { continent, country_code: countryCode } = (await GeoIP.get()) || {};

  // Uncomment to test customs invoice from any country
  // const countryCode = 'IT';
  // const continent = 'EU';

  if (countryCode === undefined) {
    window.SolarisCart.checkoutHandler.registerPromise('customsAgreement', () => {
      return assureAgreementPromise();
    });

    return;
  }

  if (!['RU', 'JP'].includes(countryCode)) {
    document
      .querySelectorAll(
        '.invoice-settings, .checkout-disclaimer__invoice-value, .customs-invoice-shipping-type-container',
      )
      .forEach((el) => el.classList.remove('hidden'));

    renderEstimatesComponent();
    addListeners(continent, countryCode);
  }

  if (['RU', 'JP'].includes(countryCode)) {
    document.querySelectorAll('.checkout-disclaimer').forEach((el) => el.classList.add('hidden'));
  } else {
    window.SolarisCart.checkoutHandler.registerPromise('customsAgreement', () => {
      return assureAgreementPromise();
    });
  }
};

export const update = () => {
  const slider = document.querySelector('#customs_percentage');
  slider.dispatchEvent(new Event('change'));
};

export default { init, update };
